import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Coupon } from 'app/public/model/coupon.model';
import { CouponValidationService } from 'app/public/services/coupon-validation.service';

@Component({
  selector: 'app-roulette-coupons-settings-item',
  templateUrl: './roulette-coupons-settings-item.component.html',
  styleUrls: ['./roulette-coupons-settings-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RouletteCouponsSettingsItemComponent implements OnInit {
  @Input() coupon: Coupon;
  @Input() index: number;
  @Input() iconsList: { Id: number, Url: string }[];
  @Input() form: NgForm;

  displayLink: boolean;
  coponTextMaxLength = 10;
  coponTextMaxLength2 =9;
  coponTextMaxLength3 = 8;

  constructor(private couponValidationService: CouponValidationService) { }

  ngOnInit(): void {
    this.displayLink = !!this.coupon?.RedirectLink;
  }
  toggleLink() {
    this.displayLink = !this.displayLink;

  }
  onLinkInput() {
  const link = this.coupon.RedirectLink;
  if (!link || !link.trim()) {
    this.couponValidationService.setInvalidLinkState(this.index, false);
    return;
  }

  const isValid = this.isValidHttpUrl(link);
  this.couponValidationService.setInvalidLinkState(this.index, !isValid);
  }

 isValidHttpUrl(string) {
  try {
    const withProtocol = string.startsWith('http://') || string.startsWith('https://')
      ? string
      : 'http://' + string;
    const url = new URL(withProtocol);
    const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
    return urlRegex.test(withProtocol) && !!url.hostname && url.hostname.includes('.');
  } catch (_) {
    return false;
  }
}
  changeCouponIcon(coupon, icon) {
    coupon.IconUrl = icon.Url;
    coupon.IconId = icon.Id;
    this.form.form.markAsDirty();
  }
}
